module.exports = __webpack_public_path__ + "static/media/led-matrix_green.6f8cf9b9.svg";